import { render, staticRenderFns } from "./UrlAttributes.vue?vue&type=template&id=f77d0840"
import script from "./UrlAttributes.vue?vue&type=script&lang=js"
export * from "./UrlAttributes.vue?vue&type=script&lang=js"
import style0 from "./UrlAttributes.vue?vue&type=style&index=0&id=f77d0840&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports